import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { pausedPaymentsCompleted, pausedPaymentsUpdated } from "store/actions/pausedPaymentsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { PausedPaymentsFooterProps } from "models/propTypes/paymentPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { usePausedPaymentsService } from "serviceHooks";

const PausedPaymentsFooter: React.FC<PausedPaymentsFooterProps> = (props) => {
  const pausedPaymentsService = usePausedPaymentsService();
  const { selectedPayments, reloadHandler, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  const onResumePaymentsSuccess = () => {
    reloadHandler &&
      reloadHandler((item) => {
        if (item && item.pausedPaymentList && item.pausedPaymentList.length > 0) {
          dispatch(pausedPaymentsUpdated(item));
        } else {
          dispatch(pausedPaymentsCompleted(0));
        }
      });
  };

  const onResumePayments = () => {
    const paymentsToResume: number[] = selectedPayments.map((p) => p.id);
    return pausedPaymentsService.resumePausedPayments(paymentsToResume);
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Payments.Pay
          )}${` (${selectedPayments.length})`}`,
          onClick: onResumePayments,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Payments.PausedPaymentsResumeSuccess
          ),
          isDisabled: selectedPayments.length === 0 || !props.isValid,
          onActionSuccess: onResumePaymentsSuccess,
        },
      ]}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default PausedPaymentsFooter;
